import { useState } from 'react';
import { useAuditLog } from '../lib/queries.js';

export function AuditPage() {
  const [filter, setFilter] = useState('');
  const { data, isLoading } = useAuditLog({ action: filter || undefined });

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-6">Audit log</h1>
      <input
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        placeholder="filtrar por action (ex.: impersonate.start, plan.created, user.banned)"
        className="w-full mb-4 rounded-md bg-zinc-900 border border-zinc-800 px-3 py-2 text-sm font-mono"
      />
      {isLoading && <div className="text-zinc-500">carregando…</div>}
      <div className="rounded-lg border border-zinc-800 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-xs uppercase text-zinc-500">
            <tr>
              <th className="text-left py-2 px-3">When</th>
              <th className="text-left">Actor</th>
              <th className="text-left">Action</th>
              <th className="text-left">Target</th>
              <th className="text-left">IP</th>
            </tr>
          </thead>
          <tbody>
            {data?.events.map((e) => (
              <tr key={e.id} className="border-t border-zinc-800/50">
                <td className="py-2 px-3 text-xs text-zinc-500">
                  {new Date(e.createdAt).toLocaleString()}
                </td>
                <td>
                  <span className={`text-xs rounded px-1.5 py-0.5 ${e.actorType === 'admin' ? 'bg-rose-950 text-rose-400' : 'bg-zinc-800 text-zinc-400'}`}>
                    {e.actorType}
                  </span>
                </td>
                <td className="font-mono text-xs">{e.action}</td>
                <td className="text-xs text-zinc-400">
                  {e.targetType ?? '—'} {e.targetId ? <code className="text-xs">{e.targetId.slice(0, 8)}</code> : null}
                </td>
                <td className="text-xs text-zinc-500 font-mono">{e.ip ?? '—'}</td>
              </tr>
            ))}
            {data?.events.length === 0 && (
              <tr>
                <td colSpan={5} className="py-6 text-center text-zinc-500">
                  nenhum evento
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
